import { getAuthorization } from 'controllers/controller';
import { getScoresStatsService } from 'services/dashboard/getScoresStats';

export const getScoresStats = async ({
  jobId,
  expMatchScore,
  overallScore,
  skillMatchScore,
  titleMatchScore,
}) => {
  const authorization = getAuthorization();

  const { data } = await getScoresStatsService(authorization, {
    jobId,
    expMatchScore,
    overallScore,
    skillMatchScore,
    titleMatchScore,
  });

  return data.response.resultMap;
};
